import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IConfigurationFormMeta {
    id: FormInputMeta;
    configuration: FormInputMeta;
    states: FormInputMeta;
    designation: FormInputMeta;
    fits: FormInputMeta;
    fdk: FormInputMeta;
    settings: FormInputMeta;
    fkdSchema: FormInputMeta;
    screens: FormInputMeta;
    services: FormInputMeta;
    keys: FormInputMeta;
    answer: FormInputMeta;
    partialStates: FormInputMeta;
    printFormat: FormInputMeta;

    schema: any;
}

const configurationFormMeta = {} as IConfigurationFormMeta;

configurationFormMeta.id = {
    name: "id",
    type: "text",
    label: "ID",
    placeholder: "ID",
    validation: yup.string().required("Champ obligatoire !"),
};

configurationFormMeta.configuration = {
    name: "configuration",
    type: "text",
    label: "Configuration",
    placeholder: "Configuration",
    validation: yup.string().required("Champ obligatoire !"),
};

configurationFormMeta.states = {
    name: "states",
    type: "select",
    label: "Etats",
    validation: yup.string(),
};

configurationFormMeta.designation = {
    name: "designation",
    type: "select",
    label: "Dénomination",
    validation: yup.string(),
};

configurationFormMeta.fits = {
    name: "fits",
    type: "select",
    label: "Fits",
    validation: yup.string(),
};

configurationFormMeta.fdk = {
    name: "fdk",
    type: "select",
    label: "F D K",
    validation: yup.string(),
};

configurationFormMeta.settings = {
    name: "settings",
    type: "select",
    label: "Paramètres",
    validation: yup.string(),
};

configurationFormMeta.fkdSchema = {
    name: "fkdSchema",
    type: "select",
    label: "F D K Schéma",
    validation: yup.string(),
};

configurationFormMeta.screens = {
    name: "screens",
    type: "select",
    label: "Ecrans",
    validation: yup.string(),
};

configurationFormMeta.services = {
    name: "services",
    type: "select",
    label: "Services",
    validation: yup.string(),
};

configurationFormMeta.keys = {
    name: "keys",
    type: "select",
    label: "Clés",
    validation: yup.string(),
};

configurationFormMeta.answer = {
    name: "answer",
    type: "select",
    label: "Réponse",
    validation: yup.string(),
};

configurationFormMeta.partialStates = {
    name: "partialStates",
    type: "select",
    label: "Etats Partiels",
    validation: yup.string(),
};

configurationFormMeta.printFormat = {
    name: "printFormat",
    type: "select",
    label: "Format d'impr.",
    validation: yup.string(),
};



configurationFormMeta.schema = yup.object().shape(getValidationSchema(configurationFormMeta));

export default configurationFormMeta;